/**
 * Vollständiger Auto-Q&A-Anlasskatalog (Paket 25).
 *
 * Ein Anlass beschreibt ausschließlich, was geschehen ist. Projekt-, Ziel-
 * und Ereignismerkmale werden im Bedingungseditor eingeschränkt. Die
 * Definitionen stehen hier, damit Oberfläche, tRPC, MCP, Motor und Tests
 * dieselbe Auswahl, Gruppierung und Zielmatrix verwenden.
 */
import { VORGAENGE, VORGANG_LABELS } from "./ereignisse.js";
export const QA_ZIELARTEN = [
    "projekt",
    "merge_request",
    "pipeline",
    "auslieferung",
    "commit",
    "meilenstein",
    "arbeitspaket",
    "aufgabe",
    "akzeptanzkriterium",
    "seite",
    "textstelle",
    "kommentar",
    "klaerung",
    "durchsicht",
    "befund",
    "qa_auftrag",
    "quality_gate",
    "automation",
    "regel",
    "metarr_entwurf",
    "metarr_code_arbeitspaket",
    "metarr_plan",
    "metarr_planaktion",
    "metarr_hausmeister_lauf",
    "aufgabenserie",
    "abwesenheit",
    "kapazitaet",
    "mcp_zugang",
    "kalenderzugang",
    "system",
];
export const QA_ZIELART_LABEL = {
    projekt: "Projekt",
    merge_request: "Merge Request",
    pipeline: "Pipeline",
    auslieferung: "Auslieferung",
    commit: "Commit",
    meilenstein: "Meilenstein",
    arbeitspaket: "Arbeitspaket",
    aufgabe: "Aufgabe oder Unteraufgabe",
    akzeptanzkriterium: "Akzeptanzkriterium",
    seite: "Seite",
    textstelle: "Textstelle",
    kommentar: "Kommentar",
    klaerung: "Klärung",
    durchsicht: "Durchsicht",
    befund: "Befund",
    qa_auftrag: "Auto-Q&A-Auftrag",
    quality_gate: "Quality Gate",
    automation: "Automation",
    regel: "Regel",
    metarr_entwurf: "Metarr-Entwurf",
    metarr_code_arbeitspaket: "Metarr-Code-Arbeitspaket",
    metarr_plan: "Metarr-Projektplan",
    metarr_planaktion: "Metarr-Planaktion",
    metarr_hausmeister_lauf: "Metarr-Hausmeisterlauf",
    aufgabenserie: "Aufgabenserie",
    abwesenheit: "Abwesenheit",
    kapazitaet: "Kapazitätslage",
    mcp_zugang: "MCP-Zugang",
    kalenderzugang: "Kalenderzugang",
    system: "System- oder Integrationslage",
};
export const QA_ANLASS_QUELLEN = [
    "gitlab",
    "fachereignis",
    "qualitaet",
    "metarr",
    "zeit",
    "system",
    "manuell",
];
export const QA_ANLASS_GRUPPEN = [
    "Merge Requests",
    "Pipelines und Jobs",
    "Commits, Branches und Tags",
    "Releases und Deployments",
    "Auto Q&A und Durchsichten",
    "Befunde",
    "Quality Gates und Merge",
    "Meilensteine",
    "Arbeitspakete",
    "Aufgaben und Unteraufgaben",
    "Akzeptanzkriterien",
    "Abhängigkeiten",
    "Seiten und Versionierung",
    "Kommentare, Marken und Klärungen",
    "Metarr",
    "Zeit, Kapazität und Serien",
    "System und Integrationen",
    "Allgemeine Fachereignisse",
];
export const MR_ANLAESSE = [
    ["mr_eroeffnet", "Merge Request eröffnet"],
    ["mr_wiedereroeffnet", "Merge Request wiedereröffnet"],
    ["mr_aktualisiert", "Merge Request aktualisiert"],
    ["mr_zum_merge_bereit", "Merge Request zum Merge bereit"],
    ["mr_geschlossen", "Merge Request geschlossen"],
    ["mr_zusammengefuehrt", "Merge Request zusammengeführt"],
    ["mr_entwurf_aktiviert", "Merge Request als Entwurf markiert"],
    ["mr_genehmigt", "Merge Request genehmigt"],
    ["mr_genehmigung_entzogen", "MR-Genehmigung entzogen"],
    ["mr_freigabeschwelle_erreicht", "MR-Freigabeschwelle erreicht"],
    ["mr_freigabeschwelle_verloren", "MR-Freigabeschwelle verloren"],
    ["mr_quellzweig_geaendert", "MR-Quellzweig geändert"],
    ["mr_zielzweig_geaendert", "MR-Zielzweig geändert"],
    ["mr_titel_geaendert", "MR-Titel geändert"],
    ["mr_beschreibung_geaendert", "MR-Beschreibung geändert"],
    ["mr_konflikt_entstanden", "MR-Konflikt entstanden"],
    ["mr_konflikt_geloest", "MR-Konflikt gelöst"],
    ["mr_diskussion_eroeffnet", "MR-Diskussion eröffnet"],
    ["mr_diskussion_geloest", "MR-Diskussion gelöst"],
    ["mr_pruefer_zugewiesen", "MR-Prüfer zugewiesen"],
    ["mr_pruefer_entfernt", "MR-Prüfer entfernt"],
    ["mr_label_hinzugefuegt", "MR-Label hinzugefügt"],
    ["mr_label_entfernt", "MR-Label entfernt"],
    ["mr_aufgabe_zugeordnet", "Merge Request einer Aufgabe zugeordnet"],
    ["mr_ohne_aufgabenzuordnung", "Merge Request ohne Aufgabenzuordnung"],
    ["mr_gesperrt", "Merge Request gesperrt"],
    ["mr_entsperrt", "Merge Request entsperrt"],
    ["mr_unzugeordnet", "Merge Request konnte nicht zugeordnet werden"],
    ["mr_nachtraeglich_zugeordnet", "Merge Request nachträglich zugeordnet"],
    ["mr_lange_unveraendert", "Merge Request lange unverändert"],
];
export const PIPELINE_ANLAESSE = [
    ["pipeline_angelegt", "Pipeline angelegt"],
    ["pipeline_gestartet", "Pipeline gestartet"],
    ["pipeline_erfolgreich", "Pipeline erfolgreich"],
    ["pipeline_gescheitert", "Pipeline gescheitert"],
    ["pipeline_abgebrochen", "Pipeline abgebrochen"],
    ["pipeline_uebersprungen", "Pipeline übersprungen"],
    ["pipeline_manuelle_aktion_noetig", "Pipeline wartet auf manuelle Aktion"],
    ["pipeline_wartet_auf_ressource", "Pipeline wartet auf Ressource"],
    ["pipeline_vorbereitung_haengt", "Pipeline-Vorbereitung hängt"],
    ["pipeline_neu_gestartet", "Pipeline neu gestartet"],
    ["pipeline_fuer_mr_veraltet", "Pipeline für MR veraltet"],
    ["pipeline_laufzeit_ueberschritten", "Pipeline-Laufzeit überschritten"],
    ["pipeline_wartedauer_ueberschritten", "Pipeline-Wartedauer überschritten"],
    ["job_gescheitert", "Pipeline-Job gescheitert"],
    ["job_wieder_erfolgreich", "Pipeline-Job wieder erfolgreich"],
    ["pflichtjob_uebersprungen", "Pflichtjob übersprungen"],
    ["nicht_erlaubter_fehler_ignoriert", "Nicht erlaubter Fehler ignoriert"],
    ["artefakt_bereit", "Pipeline-Artefakt bereit"],
    ["artefakt_abgelaufen", "Pipeline-Artefakt abgelaufen"],
];
export const CODE_ANLAESSE = [
    ["commit_mit_aufgabe_verknuepft", "Commit mit Aufgabe verknüpft"],
    ["commit_ohne_aufgabenkennung", "Commit ohne Aufgabenkennung"],
    ["branch_erstellt", "Branch erstellt"],
    ["branch_aktualisiert", "Branch aktualisiert"],
    ["branch_geloescht", "Branch gelöscht"],
    ["force_push_erkannt", "Force-Push erkannt"],
    ["geschuetzter_branch_direkt_beschrieben", "Geschützter Branch direkt beschrieben"],
    ["tag_erstellt", "Tag erstellt"],
    ["tag_geloescht", "Tag gelöscht"],
    ["tag_verschoben", "Tag verschoben"],
];
export const RELEASE_ANLAESSE = [
    ["auslieferung_angelegt", "Auslieferung angelegt"],
    ["release_angelegt", "Release angelegt"],
    ["release_aktualisiert", "Release aktualisiert"],
    ["release_geloescht", "Release gelöscht"],
    ["auslieferung_aufgabe_hinzugefuegt", "Aufgabe zur Auslieferung hinzugefügt"],
    ["auslieferung_aufgabe_entfernt", "Aufgabe aus Auslieferung entfernt"],
    ["auslieferung_ohne_aufgaben", "Auslieferung ohne Aufgaben"],
    ["auslieferung_mit_offenen_aufgaben", "Auslieferung mit offenen Aufgaben"],
    ["auslieferung_mit_offenen_akzeptanzkriterien", "Auslieferung mit offenen Akzeptanzkriterien"],
    ["deployment_gestartet", "Deployment gestartet"],
    ["deployment_erfolgreich", "Deployment erfolgreich"],
    ["deployment_gescheitert", "Deployment gescheitert"],
    ["deployment_abgebrochen", "Deployment abgebrochen"],
    ["rollback_gestartet", "Rollback gestartet"],
    ["rollback_erfolgreich", "Rollback erfolgreich"],
    ["produktionsdeployment_ohne_gate", "Produktionsdeployment ohne Quality Gate"],
];
export const QA_LAUF_ANLAESSE = [
    ["qa_auftrag_angelegt", "Auto-Q&A-Auftrag angelegt"],
    ["qa_auftrag_gestartet", "Auto-Q&A-Auftrag gestartet"],
    ["qa_auftrag_sauber_beendet", "Auto-Q&A-Auftrag sauber beendet"],
    ["qa_auftrag_mit_aufhaltern_beendet", "Auto-Q&A-Auftrag mit Aufhaltern beendet"],
    ["qa_auftrag_nicht_bewertbar", "Auto-Q&A-Auftrag nicht bewertbar"],
    ["qa_auftrag_gescheitert", "Auto-Q&A-Auftrag gescheitert"],
    ["qa_auftrag_abgebrochen", "Auto-Q&A-Auftrag abgebrochen"],
    ["qa_auftrag_steckengeblieben", "Auto-Q&A-Auftrag steckengeblieben"],
    ["qa_auftrag_wiederaufgenommen", "Auto-Q&A-Auftrag wiederaufgenommen"],
    ["qa_budget_erschoepft", "Auto-Q&A-Budget erschöpft"],
    ["qa_schritt_uebersprungen", "Auto-Q&A-Schritt übersprungen"],
    ["qa_rezept_fehlt", "Auto-Q&A-Rezept fehlt"],
    ["qa_diff_gekuerzt", "Auto-Q&A-Diff gekürzt"],
    ["durchsicht_wiederholt", "Durchsicht wiederholt"],
];
export const BEFUND_ANLAESSE = [
    ["befund_angelegt", "Befund angelegt"],
    ["blockierender_befund_angelegt", "Blockierender Befund angelegt"],
    ["befund_schwere_erhoeht", "Befundschwere erhöht"],
    ["befund_schwere_verringert", "Befundschwere verringert"],
    ["befund_uebernommen", "Befund übernommen"],
    ["befund_abgelehnt", "Befund abgelehnt"],
    ["befund_zurueckgestellt", "Befund zurückgestellt"],
    ["befund_wiedereroeffnet", "Befund wiedereröffnet"],
    ["befund_nachweislich_behoben", "Befund nachweislich behoben"],
    ["alle_blockierenden_befunde_geloest", "Alle blockierenden Befunde gelöst"],
    ["befund_ohne_beleg_verworfen", "Befund ohne Beleg verworfen"],
    ["befund_dublette_erkannt", "Befund-Dublette erkannt"],
];
export const GATE_ANLAESSE = [
    ["quality_gate_bestanden", "Quality Gate bestanden"],
    ["quality_gate_ausstehend", "Quality Gate ausstehend"],
    ["quality_gate_blockiert", "Quality Gate blockiert"],
    ["quality_gate_nicht_bewertbar", "Quality Gate nicht bewertbar"],
    ["quality_gate_veraltet", "Quality Gate veraltet"],
    ["quality_gate_haette_blockiert", "Quality Gate hätte blockiert"],
    ["quality_gate_uebersteuert", "Quality Gate übersteuert"],
    ["quality_gate_uebersteuerung_ungueltig_geworden", "Gate-Übersteuerung ungültig geworden"],
    ["quality_gate_regel_geaendert", "Quality-Gate-Regel geändert"],
    ["quality_gate_scharfgeschaltet", "Quality Gate scharfgeschaltet"],
    ["quality_gate_in_schattenbetrieb_gesetzt", "Quality Gate in Schattenbetrieb gesetzt"],
    ["merge_freigegeben", "Merge freigegeben"],
    ["merge_abgewiesen", "Merge abgewiesen"],
    ["merge_bestaetigt", "Merge bestätigt"],
    ["merge_ausgang_unklar", "Merge-Ausgang unklar"],
];
export const MEILENSTEIN_ANLAESSE = [
    ["meilenstein_angelegt", "Meilenstein angelegt"],
    ["meilenstein_geaendert", "Meilenstein geändert"],
    ["meilenstein_archiviert", "Meilenstein archiviert"],
    ["meilenstein_wiederhergestellt", "Meilenstein wiederhergestellt"],
    ["meilenstein_frist_geaendert", "Meilensteinfrist geändert"],
    ["meilenstein_in_30_tagen_faellig", "Meilenstein in 30 Tagen fällig"],
    ["meilenstein_in_14_tagen_faellig", "Meilenstein in 14 Tagen fällig"],
    ["meilenstein_in_7_tagen_faellig", "Meilenstein in 7 Tagen fällig"],
    ["meilenstein_in_1_tag_faellig", "Meilenstein morgen fällig"],
    ["meilenstein_heute_faellig", "Meilenstein heute fällig"],
    ["meilenstein_ueberfaellig", "Meilenstein überfällig"],
    ["meilenstein_erreicht", "Meilenstein erreicht"],
    ["meilenstein_alle_arbeitspakete_vollstaendig", "Alle Arbeitspakete des Meilensteins vollständig"],
    ["meilenstein_wieder_unvollstaendig", "Meilenstein wieder unvollständig"],
    ["meilenstein_blockiert", "Meilenstein blockiert"],
    ["meilenstein_entblockt", "Meilenstein entblockt"],
    ["meilenstein_ohne_arbeitspakete", "Meilenstein ohne Arbeitspakete"],
    ["meilenstein_mit_ueberfaelligen_arbeitspaketen", "Meilenstein mit überfälligen Arbeitspaketen"],
];
export const ARBEITSPAKET_ANLAESSE = [
    ["arbeitspaket_angelegt", "Arbeitspaket angelegt"],
    ["arbeitspaket_geaendert", "Arbeitspaket geändert"],
    ["arbeitspaket_verschoben", "Arbeitspaket verschoben"],
    ["arbeitspaket_archiviert", "Arbeitspaket archiviert"],
    ["arbeitspaket_wiederhergestellt", "Arbeitspaket wiederhergestellt"],
    ["arbeitspaket_meilenstein_geaendert", "Arbeitspaket anderem Meilenstein zugeordnet"],
    ["arbeitspaket_frist_gesetzt", "Arbeitspaketfrist gesetzt"],
    ["arbeitspaket_frist_entfernt", "Arbeitspaketfrist entfernt"],
    ["arbeitspaket_frist_verschoben", "Arbeitspaketfrist verschoben"],
    ["arbeitspaket_bald_faellig", "Arbeitspaket bald fällig"],
    ["arbeitspaket_ueberfaellig", "Arbeitspaket überfällig"],
    ["arbeitspaket_erste_aufgabe_angelegt", "Erste Aufgabe im Arbeitspaket angelegt"],
    ["arbeitspaket_alle_aufgaben_abgeschlossen", "Alle Aufgaben im Arbeitspaket abgeschlossen"],
    ["arbeitspaket_abgeschlossen", "Arbeitspaket abgeschlossen"],
    ["arbeitspaket_wiedereroeffnet", "Arbeitspaket wiedereröffnet"],
    ["arbeitspaket_blockiert", "Arbeitspaket blockiert"],
    ["arbeitspaket_entblockt", "Arbeitspaket entblockt"],
    ["arbeitspaket_ohne_aufgaben", "Arbeitspaket ohne Aufgaben"],
    ["arbeitspaket_ohne_verantwortliche_person", "Arbeitspaket ohne verantwortliche Person"],
    ["arbeitspaket_mit_offenen_akzeptanzkriterien", "Arbeitspaket mit offenen Akzeptanzkriterien"],
];
export const AUFGABEN_ANLAESSE = [
    ["aufgabe_angelegt", "Aufgabe angelegt"],
    ["aufgabe_beschreibung_geaendert", "Aufgabenbeschreibung geändert"],
    ["aufgabe_art_geaendert", "Aufgabenart geändert"],
    ["aufgabe_status_gewechselt", "Aufgabenstatus gewechselt"],
    ["aufgabe_in_arbeit_genommen", "Aufgabe in Arbeit genommen"],
    ["aufgabe_zur_abnahme_gestellt", "Aufgabe zur Abnahme gestellt"],
    ["aufgabe_abgeschlossen", "Aufgabe abgeschlossen"],
    ["aufgabe_wiedereroeffnet", "Aufgabe wiedereröffnet"],
    ["aufgabe_verworfen", "Aufgabe verworfen"],
    ["aufgabe_prioritaet_erhoeht", "Aufgabenpriorität erhöht"],
    ["aufgabe_prioritaet_verringert", "Aufgabenpriorität verringert"],
    ["aufgabe_frist_gesetzt", "Aufgabenfrist gesetzt"],
    ["aufgabe_frist_entfernt", "Aufgabenfrist entfernt"],
    ["aufgabe_frist_verschoben", "Aufgabenfrist verschoben"],
    ["aufgabe_bald_faellig", "Aufgabe bald fällig"],
    ["aufgabe_heute_faellig", "Aufgabe heute fällig"],
    ["aufgabe_ueberfaellig", "Aufgabe überfällig"],
    ["aufgabe_schaetzung_geaendert", "Aufgabenschätzung geändert"],
    ["aufgabe_person_zugewiesen", "Person einer Aufgabe zugewiesen"],
    ["aufgabe_person_entfernt", "Person von Aufgabe entfernt"],
    ["aufgabe_vollstaendig_unzugewiesen", "Aufgabe vollständig unzugewiesen"],
    ["aufgabe_label_hinzugefuegt", "Aufgabenlabel hinzugefügt"],
    ["aufgabe_label_entfernt", "Aufgabenlabel entfernt"],
    ["unteraufgabe_angelegt", "Unteraufgabe angelegt"],
    ["unteraufgabe_verschoben", "Unteraufgabe verschoben"],
    ["unteraufgabe_erste_abgeschlossen", "Erste Unteraufgabe abgeschlossen"],
    ["unteraufgabe_alle_abgeschlossen", "Alle Unteraufgaben abgeschlossen"],
    ["unteraufgabe_wiedereroeffnet", "Unteraufgabe wiedereröffnet"],
    ["aufgabe_archiviert", "Aufgabe archiviert"],
    ["aufgabe_wiederhergestellt", "Aufgabe wiederhergestellt"],
    ["aufgabe_verknuepft", "Aufgabe verknüpft"],
    ["aufgabe_verknuepfung_entfernt", "Aufgabenverknüpfung entfernt"],
];
export const AKZEPTANZ_ANLAESSE = [
    ["akzeptanzkriterium_angelegt", "Akzeptanzkriterium angelegt"],
    ["akzeptanzkriterium_text_geaendert", "Akzeptanzkriterium geändert"],
    ["akzeptanzkriterium_erfuellt", "Akzeptanzkriterium erfüllt"],
    ["akzeptanzkriterium_wieder_geoeffnet", "Akzeptanzkriterium wieder geöffnet"],
    ["akzeptanzkriterium_geloescht", "Akzeptanzkriterium gelöscht"],
    ["aufgabe_erstes_akzeptanzkriterium", "Erstes Akzeptanzkriterium angelegt"],
    ["aufgabe_alle_akzeptanzkriterien_erfuellt", "Alle Akzeptanzkriterien erfüllt"],
    ["aufgabe_akzeptanzkriterien_wieder_offen", "Akzeptanzkriterien wieder offen"],
    ["aufgabe_ohne_akzeptanzkriterien_zur_abnahme", "Aufgabe ohne Akzeptanzkriterien zur Abnahme"],
    ["aufgabe_mit_offenen_akzeptanzkriterien_abgeschlossen", "Aufgabe mit offenen Akzeptanzkriterien abgeschlossen"],
];
export const ABHAENGIGKEITS_ANLAESSE = [
    ["abhaengigkeit_gesetzt", "Abhängigkeit gesetzt"],
    ["abhaengigkeit_entfernt", "Abhängigkeit entfernt"],
    ["planitem_blockiert", "Planobjekt blockiert"],
    ["planitem_entblockt", "Planobjekt entblockt"],
    ["voraussetzung_abgeschlossen", "Voraussetzung abgeschlossen"],
    ["voraussetzung_wiedereroeffnet", "Voraussetzung wiedereröffnet"],
    ["mehrere_blockaden_vorhanden", "Mehrere Blockaden vorhanden"],
    ["ebenenuebergreifende_blockade_gesetzt", "Ebenenübergreifende Blockade gesetzt"],
    ["abhaengigkeitszyklus_abgewiesen", "Abhängigkeitszyklus abgewiesen"],
];
export const SEITEN_ANLAESSE = [
    ["seite_angelegt", "Seite angelegt"],
    ["seite_inhalt_geaendert", "Seiteninhalt geändert"],
    ["seite_umbenannt", "Seite umbenannt"],
    ["seite_verschoben", "Seite verschoben"],
    ["seite_archiviert", "Seite archiviert"],
    ["seite_wiederhergestellt", "Seite wiederhergestellt"],
    ["seite_erste_unversionierte_aenderung", "Erste unversionierte Seitenänderung"],
    ["seitenversionierung_faellig", "Seitenversionierung fällig"],
    ["seitenfassung_angelegt", "Seitenfassung angelegt"],
    ["seiten_gitlab_uebertragung_erfolgreich", "Seite zu GitLab übertragen"],
    ["seiten_gitlab_uebertragung_gescheitert", "Seitenübertragung zu GitLab gescheitert"],
    ["seiten_gitlab_abweichung", "GitLab-Abweichung einer Seite festgestellt"],
    ["seiten_gitlab_wieder_erfolgreich", "Seitenübertragung wieder erfolgreich"],
    ["seiten_gitlab_wiederholungen_erschoepft", "Wiederholungen der Seitenübertragung erschöpft"],
    ["seite_ungueltige_verweise", "Seite enthält ungültige Verweise"],
];
export const KOMMUNIKATIONS_ANLAESSE = [
    ["kommentar_angelegt", "Kommentar angelegt"],
    ["kommentar_geaendert", "Kommentar geändert"],
    ["kommentar_geloescht", "Kommentar gelöscht"],
    ["person_erwaehnt", "Person erwähnt"],
    ["reaktion_hinzugefuegt", "Kommentarreaktion hinzugefügt"],
    ["reaktion_entfernt", "Kommentarreaktion entfernt"],
    ["textmarke_gesetzt", "Textmarke gesetzt"],
    ["textmarke_geloest", "Textmarke gelöst"],
    ["klaerung_gestellt", "Klärung gestellt"],
    ["klaerung_beantwortet", "Klärung beantwortet"],
    ["klaerung_geschlossen", "Klärung geschlossen"],
    ["klaerung_verworfen", "Klärung verworfen"],
    ["klaerung_wiedereroeffnet", "Klärung wiedereröffnet"],
    ["klaerung_unbeantwortet", "Klärung lange unbeantwortet"],
    ["alle_klaerungen_beantwortet", "Alle Klärungen beantwortet"],
    ["klaerung_an_abgeschlossenem_item", "Klärung an abgeschlossenem Planobjekt"],
];
export const METARR_ANLAESSE = [
    ["metarr_entwurf_angelegt", "Metarr-Entwurf angelegt"],
    ["metarr_verarbeitung_gestartet", "Metarr-Verarbeitung gestartet"],
    ["metarr_rueckfrage_erforderlich", "Metarr-Rückfrage erforderlich"],
    ["metarr_rueckfrage_beantwortet", "Metarr-Rückfrage beantwortet"],
    ["metarr_entwurf_verarbeitet", "Metarr-Entwurf verarbeitet"],
    ["metarr_verarbeitung_wiederholt", "Metarr-Verarbeitung wird wiederholt"],
    ["metarr_verarbeitung_gescheitert", "Metarr-Verarbeitung gescheitert"],
    ["metarr_vorschlag_angelegt", "Metarr-Vorschlag angelegt"],
    ["metarr_vorschlag_angenommen", "Metarr-Vorschlag angenommen"],
    ["metarr_vorschlag_abgelehnt", "Metarr-Vorschlag abgelehnt"],
    ["metarr_vorschlag_veraltet", "Metarr-Vorschlag veraltet"],
    ["metarr_code_planung_begonnen", "Metarr-Codeplanung begonnen"],
    ["metarr_code_plan_zur_bestaetigung", "Metarr-Codeplan zur Bestätigung bereit"],
    ["metarr_code_plan_freigegeben", "Metarr-Codeplan freigegeben"],
    ["metarr_code_plan_abgelehnt", "Metarr-Codeplan abgelehnt"],
    ["metarr_code_veroeffentlichung_wartet", "Metarr-Codeveröffentlichung wartet"],
    ["metarr_code_commit_erstellt", "Metarr-Codecommit erstellt"],
    ["metarr_code_mr_veroeffentlicht", "Metarr-Code-MR veröffentlicht"],
    ["metarr_code_ohne_mr_fertig", "Metarr-Codearbeit ohne MR fertig"],
    ["metarr_code_zu_gross", "Metarr-Codearbeit zu groß"],
    ["metarr_code_konflikt", "Metarr-Codekonflikt"],
    ["metarr_code_veroeffentlichung_gescheitert", "Metarr-Codeveröffentlichung gescheitert"],
    ["metarr_code_gescheitert", "Metarr-Codearbeit gescheitert"],
    ["metarr_code_abgebrochen", "Metarr-Codearbeit abgebrochen"],
    ["metarr_code_wiederholung_vorgesehen", "Metarr-Codearbeit wird wiederholt"],
    ["metarr_projektplan_angelegt", "Metarr-Projektplan angelegt"],
    ["metarr_projektplan_teilweise_angenommen", "Metarr-Projektplan teilweise angenommen"],
    ["metarr_projektplan_ausgefuehrt", "Metarr-Projektplan ausgeführt"],
    ["metarr_projektplan_abgelehnt", "Metarr-Projektplan abgelehnt"],
    ["metarr_projektplan_gescheitert", "Metarr-Projektplan gescheitert"],
    ["metarr_planaktion_blockiert", "Metarr-Planaktion blockiert"],
    ["metarr_planaktion_ausgefuehrt", "Metarr-Planaktion ausgeführt"],
    ["metarr_hausmeister_gestartet", "Metarr-Hausmeisterlauf gestartet"],
    ["metarr_hausmeister_mit_vorschlaegen", "Metarr-Hausmeisterlauf mit Vorschlägen beendet"],
    ["metarr_hausmeister_ohne_befund", "Metarr-Hausmeisterlauf ohne Befund beendet"],
    ["metarr_hausmeister_gescheitert", "Metarr-Hausmeisterlauf gescheitert"],
];
export const ZEIT_ANLAESSE = [
    ["manuell_ausgeloest", "Manuell ausgelöst"],
    ["zeitplan_ausgeloest", "Nach Zeitplan ausgelöst"],
    ["item_unveraendert", "Planobjekt lange unverändert"],
    ["item_zu_lange_im_status", "Planobjekt zu lange im Status"],
    ["aufgabenserie_instanz_angelegt", "Neue Serienaufgabe angelegt"],
    ["aufgabenserie_beendet", "Aufgabenserie beendet"],
    ["abwesenheit_begonnen", "Abwesenheit begonnen"],
    ["abwesenheit_beendet", "Abwesenheit beendet"],
    ["kapazitaet_unterschritten", "Kapazitätsgrenze unterschritten"],
    ["arbeitslast_ueber_kapazitaet", "Arbeitslast über Kapazität"],
    ["faellige_arbeit_ohne_verfuegbare_verantwortliche_person", "Fällige Arbeit ohne verfügbare verantwortliche Person"],
    ["projekt_inaktiv", "Projekt lange inaktiv"],
];
export const SYSTEM_ANLAESSE = [
    ["gitlab_webhook_fehlgeschlagen", "GitLab-Webhook fehlgeschlagen"],
    ["gitlab_webhook_wiederholt_verarbeitet", "GitLab-Webhook nach Wiederholung verarbeitet"],
    ["gitlab_webhook_steckengeblieben", "GitLab-Webhook steckengeblieben"],
    ["gitlab_nachzug_fehlgeschlagen", "GitLab-Nachzug fehlgeschlagen"],
    ["gitlab_nachzug_wieder_gesund", "GitLab-Nachzug wieder gesund"],
    ["ki_anbieter_test_fehlgeschlagen", "KI-Anbietertest fehlgeschlagen"],
    ["ki_anbieter_wieder_erfolgreich", "KI-Anbieter wieder erreichbar"],
    ["worker_steckengeblieben", "Worker steckengeblieben"],
    ["worker_freigegeben", "Worker wieder freigegeben"],
    ["seiten_outbox_dauerhaft_gescheitert", "Seiten-Outbox dauerhaft gescheitert"],
    ["mcp_zugang_angelegt", "MCP-Zugang angelegt"],
    ["mcp_zugang_geaendert", "MCP-Zugang geändert"],
    ["mcp_zugang_widerrufen", "MCP-Zugang widerrufen"],
    ["mcp_zugang_lange_unbenutzt", "MCP-Zugang lange unbenutzt"],
    ["kalenderzugang_widerrufen", "Kalenderzugang widerrufen"],
    ["regel_lauf_abgewiesen", "Regellauf abgewiesen"],
    ["automationslauf_abgewiesen", "Automationslauf abgewiesen"],
    ["regeltiefengrenze_erreicht", "Regeltiefengrenze erreicht"],
    ["markenbudget_ungewoehnlich_hoch", "Markenbudget ungewöhnlich hoch"],
    ["markenbudget_erschoepft", "Markenbudget erschöpft"],
];
export const QA_ZEITPLAN_INTERVALLE = [
    "stuendlich",
    "taeglich",
    "woechentlich",
];
const ISO_WOCHENTAG = {
    Mon: 1,
    Tue: 2,
    Wed: 3,
    Thu: 4,
    Fri: 5,
    Sat: 6,
    Sun: 7,
};
/**
 * Nächster Ausführungstermin in der konfigurierten IANA-Zeitzone.
 *
 * Die minutengenaue Suche wirkt unspektakulär, behandelt aber Sommerzeit
 * korrekt: nicht existente Ortszeiten werden übersprungen, doppelte Zeiten
 * werden als zwei reale Zeitpunkte gesehen. Maximal acht Tage sind 11.520
 * billige Vergleiche und decken auch einen wöchentlichen Plan sicher ab.
 */
export function naechsterQaZeitplanLauf(zeitplan, nach) {
    const formatierer = new Intl.DateTimeFormat("en-GB", {
        timeZone: zeitplan.zeitzone,
        weekday: "short",
        hour: "2-digit",
        minute: "2-digit",
        hourCycle: "h23",
    });
    let kandidat = new Date(Math.floor(nach.getTime() / 60_000) * 60_000 + 60_000);
    const grenze = kandidat.getTime() + 8 * 24 * 60 * 60 * 1_000;
    while (kandidat.getTime() <= grenze) {
        const teile = Object.fromEntries(formatierer
            .formatToParts(kandidat)
            .filter((teil) => teil.type !== "literal")
            .map((teil) => [teil.type, teil.value]));
        const minute = Number(teile["minute"]);
        const stunde = Number(teile["hour"]);
        const wochentag = ISO_WOCHENTAG[teile["weekday"] ?? ""] ?? 0;
        const passt = minute === zeitplan.minute &&
            (zeitplan.intervall === "stuendlich" || stunde === zeitplan.stunde) &&
            (zeitplan.intervall !== "woechentlich" || wochentag === zeitplan.wochentag);
        if (passt)
            return kandidat;
        kandidat = new Date(kandidat.getTime() + 60_000);
    }
    throw new Error("Für den Zeitplan wurde innerhalb von acht Tagen kein Termin gefunden.");
}
function definiere(zeilen, gruppe, quelle, zielArten) {
    return zeilen.map(([schluessel, label]) => ({
        schluessel: schluessel,
        label,
        beschreibung: `Löst aus, wenn „${label}“ eintritt.`,
        gruppe,
        quelle,
        zielArten,
    }));
}
const PLAN_ZIELE = [
    "meilenstein",
    "arbeitspaket",
    "aufgabe",
    "akzeptanzkriterium",
];
const SPEZIFISCHE_QA_ANLASS_DEFINITIONEN = [
    ...definiere(MR_ANLAESSE, "Merge Requests", "gitlab", ["merge_request"]),
    ...definiere(PIPELINE_ANLAESSE, "Pipelines und Jobs", "gitlab", ["pipeline"]),
    ...definiere(CODE_ANLAESSE, "Commits, Branches und Tags", "gitlab", ["commit", "projekt", "merge_request"]),
    ...definiere(RELEASE_ANLAESSE, "Releases und Deployments", "gitlab", ["auslieferung", "projekt"]),
    ...definiere(QA_LAUF_ANLAESSE, "Auto Q&A und Durchsichten", "qualitaet", ["qa_auftrag", "durchsicht"]),
    ...definiere(BEFUND_ANLAESSE, "Befunde", "qualitaet", ["befund", "merge_request"]),
    ...definiere(GATE_ANLAESSE, "Quality Gates und Merge", "qualitaet", ["quality_gate", "merge_request"]),
    ...definiere(MEILENSTEIN_ANLAESSE, "Meilensteine", "fachereignis", ["meilenstein"]),
    ...definiere(ARBEITSPAKET_ANLAESSE, "Arbeitspakete", "fachereignis", ["arbeitspaket"]),
    ...definiere(AUFGABEN_ANLAESSE, "Aufgaben und Unteraufgaben", "fachereignis", ["aufgabe"]),
    ...definiere(AKZEPTANZ_ANLAESSE, "Akzeptanzkriterien", "fachereignis", ["akzeptanzkriterium", "aufgabe"]),
    ...definiere(ABHAENGIGKEITS_ANLAESSE, "Abhängigkeiten", "fachereignis", PLAN_ZIELE),
    ...definiere(SEITEN_ANLAESSE, "Seiten und Versionierung", "fachereignis", ["seite"]),
    ...definiere(KOMMUNIKATIONS_ANLAESSE, "Kommentare, Marken und Klärungen", "fachereignis", ["kommentar", "textstelle", "klaerung", "aufgabe", "seite"]),
    ...definiere(METARR_ANLAESSE, "Metarr", "metarr", ["metarr_entwurf", "metarr_code_arbeitspaket", "metarr_plan", "metarr_planaktion", "metarr_hausmeister_lauf", "merge_request"]),
    ...definiere(ZEIT_ANLAESSE, "Zeit, Kapazität und Serien", "zeit", QA_ZIELARTEN),
    ...definiere(SYSTEM_ANLAESSE, "System und Integrationen", "system", ["projekt", "system", "mcp_zugang", "kalenderzugang", "automation", "regel"]),
];
const SPEZIFISCHE_SCHLUESSEL = new Set(SPEZIFISCHE_QA_ANLASS_DEFINITIONEN.map((definition) => definition.schluessel));
export const QA_ANLASS_DEFINITIONEN = [
    ...SPEZIFISCHE_QA_ANLASS_DEFINITIONEN,
    ...VORGAENGE.filter((schluessel) => !SPEZIFISCHE_SCHLUESSEL.has(schluessel)).map((schluessel) => ({
        schluessel,
        label: VORGANG_LABELS[schluessel],
        beschreibung: `Allgemeiner Fachvorgang „${VORGANG_LABELS[schluessel]}“ aus dem Ereignisstrom.`,
        gruppe: "Allgemeine Fachereignisse",
        quelle: "fachereignis",
        zielArten: QA_ZIELARTEN,
    })),
];
const DEFINITION_NACH_SCHLUESSEL = new Map(QA_ANLASS_DEFINITIONEN.map((definition) => [definition.schluessel, definition]));
export const QA_ANLAESSE = QA_ANLASS_DEFINITIONEN.map((definition) => definition.schluessel);
export const QA_ANLASS_LABEL = Object.fromEntries(QA_ANLASS_DEFINITIONEN.map((definition) => [definition.schluessel, definition.label]));
export function istQaAnlass(wert) {
    return DEFINITION_NACH_SCHLUESSEL.has(wert);
}
export function qaAnlassDefinition(schluessel) {
    return DEFINITION_NACH_SCHLUESSEL.get(schluessel);
}
export function zielartenFuerQaAnlass(schluessel) {
    return qaAnlassDefinition(schluessel)?.zielArten ?? [];
}
/** GitLab-nahe Anlässe bleiben als eigene Auswahl für bestehende Aufrufer. */
export const GITLAB_ANLAESSE = QA_ANLASS_DEFINITIONEN.filter((definition) => definition.quelle === "gitlab").map((definition) => definition.schluessel);
export function istGitlabAnlass(wert) {
    const definition = qaAnlassDefinition(wert);
    return definition?.quelle === "gitlab";
}
//# sourceMappingURL=auto-qa-anlaesse.js.map